import Alpine, { AlpineComponent } from 'alpinejs';
import { FormValidation, FieldValidation } from '../../types/form';
import { iodine, trybaPhoneMask, zipOrCityMask } from '../../helpers/validation';

interface ParrainageFilleulsAlpine extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    form: HTMLFormElement;
    filleuls: FilleulsEsi;
    errorMessagesFilleuls: FilleulsEsi;
    handleErrorFilleul(validation: FieldValidation, name: string, filleulKey: number): void;
}

const rules = {
    civility: ['truthy'],
    firstname: ['required'],
    lastname: ['required'],
    address: ['required'],
    zip: ['required'],
    city: ['required'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
};

interface FilleulEsi {
    key: number;
    firstname: string;
    lastname: string;
    zip: string;
    city: string;
    phone: string;
    email: string;
}

type FilleulsEsi = FilleulEsi[];

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initFormValidationFilleuls', (form: HTMLFormElement,   filleuls: FilleulsEsi): ParrainageFilleulsAlpine => {
        return {
            ...{
                zipOrCityMask,
                trybaPhoneMask,
            },
            ...{
                form,
                // @ts-ignore
                filleuls: filleuls !== undefined && filleuls.length !== 0 ? filleuls : [{
                    key: 0,
                    firstname: '',
                    lastname: '',
                    zip: '',
                    city: '',
                    phone: '',
                    email: '',
                }] as FilleulsEsi,
                errorMessagesFilleuls: [],
                init(): void {
                    for(const filleul of this.filleuls) {
                        this.errorMessagesFilleuls.push({
                            key: filleul.key,
                            firstname: '',
                            lastname: '',
                            zip: '',
                            city: '',
                            phone: '',
                            email: '',
                        });
                    }
                },
                validateFieldFilleul(field: HTMLInputElement, filleulKey: number): void {
                    const name = field.dataset.name as string;
                    const validation = iodine.assert(
                        field.value,
                        rules[name],
                    ) as FieldValidation;
                    this.handleErrorFilleul(validation, name, filleulKey);

                    const checkValidateElement = field.parentElement ? field.parentElement.querySelector('[js-check-validate]') : null;
                    if (checkValidateElement) {
                        if (validation.valid) {
                            checkValidateElement.classList.remove('opacity-0')
                        } else {
                            checkValidateElement.classList.add('opacity-0')
                        }
                    }

                },
                handleErrorFilleul(validation: FieldValidation, name: string, filleulKey: number) {
                    if (validation.valid) {
                        this.errorMessagesFilleuls[filleulKey][name] = '';
                    } else {
                        this.errorMessagesFilleuls[filleulKey][name] = validation.error;
                    }
                },
                displayErrorsFilleul(validation: FormValidation, filleulKey: number) {
                    Object.keys(validation.fields).forEach((key: string) => {
                        this.errorMessagesFilleuls[filleulKey][key] = validation.fields[key].error;
                    });
                },
                addFilleul(): void {
                    const newFilleul = {
                        key: this.filleuls.length,
                        firstname: '',
                        lastname: '',
                        zip: '',
                        city: '',
                        phone: '',
                        email: '',
                        };
                    this.filleuls.push(newFilleul);
                    this.errorMessagesFilleuls.push(newFilleul);
                },
                removeFilleul(): void {
                    this.filleuls.pop();
                    this.errorMessagesFilleuls.pop();
                },
                isLastFilleul(filleulKey: number): boolean {
                    return this.filleuls.length - 1 === filleulKey;
                },
                hasFilleul(): boolean {
                    return this.filleuls.length > 1;
                },
            },
        };
    });
});
